import {
  Component,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Button } from '@openng/optimus-ui/button';
import { Tooltip } from '@openng/optimus-ui/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Button, Tooltip, TranslatePipe],
})
export class ExportComponent {
  readonly selectedItems = input<any[]>();

  readonly exportCSV = output();

  readonly clearSelections = output();

  onExportCSV() {
    this.exportCSV.emit();
  }

  onClearSelections() {
    this.clearSelections.emit();
  }
}
